
import XLSX from 'xlsx';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { headersToCheck } from '@/view/hundun/chuang/lib/upload-file';

@Component
export default class MissionDetail extends Vue {
  // @ts-ignore
  @Prop({ default: false }) visible: boolean;
  // @ts-ignore
  @Prop({ default: () => [] }) header: [];

  upload_file_list: any = [];
  file_list: any;

  beforeFileUpload(file: File) {
    if (this.upload_file_list.length == 1) return this.$message.error('最多上传一个文件，请先删除当前文件或者将文件整合在一个excel中');
    this.upload_file_list.push(file);
    this.readExcel(file);
    return false;
  }

  removeFile() {
    this.upload_file_list = [];
  }

  readExcel(file: any) {
    const fileReader = new FileReader();
    fileReader.onload = async (ev) => {
      const pre_data = ev.target;
      let data;
      if (pre_data) {
        data = pre_data.result;
      }
      const workbook = await XLSX.read(data, { type: 'binary' });
      const name = workbook.SheetNames[0]; //取第一张表
      const sheet_data = workbook.Sheets[name];
      if (!headersToCheck(sheet_data, this.header)) {
        this.upload_file_list = [];
        return this.$message.error('文件表头错误');
      }
      return this.$emit('readExcel', sheet_data);
    };
    fileReader.readAsBinaryString(file);
  }
  downloadTemplate() {
    this.$emit('downloadTemplate');
  }
  // 确认按钮
  handleOk() {
    if (this.upload_file_list.length == 0) return this.$message.error('表格数据为空！');
    this.$emit('handleOk');
  }
  // 取消按钮;
  handleCancel() {
    this.$emit('handleCancel');
  }
}
